import React, {useState} from 'react';
import {TextField} from '@mui/material';
import {useSelector} from 'react-redux';
import {getMemberIdsForGivenTeamId, writeCurrentTeamIdData} from "../../helpers/dbFunctions";
import AlertDialog from "../common/AlertDialog";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import {Flex} from "reflexbox";

const JoinTeamDialog = (props) => {

  const uid = useSelector((state) => state.user?.uid);
  const currentTeamId = useSelector((state) => state.team?.currentTeamId);

  const [joinCode, setJoinCode] = useState('');
  const [joinError, setJoinError] = useState('');


  const handleNameInputChange = (event) => {
    setJoinCode(event.target.value.trim().toUpperCase());
    setJoinError('');
  };

  const handleJoin = async () => {
    if (joinCode.length !== 6) {
      setJoinError(`Codes are 6 characters. Yours is ${joinCode.length}`);
      return (false);
    }
    if (currentTeamId === joinCode) {
      setJoinError(`You are already on this team`);
      return (false);
    }
    //check to see if code exists; if not, return an error
    const newMemberIdsArray = await getMemberIdsForGivenTeamId(joinCode);
    if (newMemberIdsArray) {
      // add my userID to the array of existing users already on the team
      newMemberIdsArray.push(uid);
      // update the back-end in both places (team association under uid & member array under teamId)
      writeCurrentTeamIdData(uid, joinCode, newMemberIdsArray);
      props.setIntentIfSuccess();
      return (true);
    } else {
      setJoinError('There is no one hosting a team with that code');
      return (false);
    }
  };

  return (
    <AlertDialog open={props.open}
                 close={props.close}
                 title={'Join a team'}
                 rightButtonText={'Join'}
                 checkBeforeContinue={handleJoin}
                 body={<Flex style={{flexDirection: 'column'}}>
                  <Typography>Enter your room code</Typography>
                   {currentTeamId && <Typography variant={'caption'} style={{paddingBottom: '16px'}}> Joining another team will cause you to leave the team you're currently on </Typography>}
                   <TextField
                   label="Invite code"
                   value={joinCode}
                   onChange={handleNameInputChange}
                 />
                   <Typography variant={'caption'} style={{minWidth: '2px', minHeight: '25px'}} color={'secondary'}>{joinError || ' '}</Typography>
                 </Flex>}
    />
  );
};

JoinTeamDialog.propTypes = {
  open: PropTypes.any.isRequired,
  close: PropTypes.any.isRequired,
  setIntentIfSuccess: PropTypes.any,
};

export default JoinTeamDialog;